<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="accountGroupData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="configure">
        <Button
          type="info"
          size="small"
          @click="accountGroupConfig(row)"
          v-hasPermission="[
            'permissionsConfigurationManagement:accountGroup:accountGroup_config'
          ]"
          >{{ $t("RIAccountGroupManagement.configuration") }}</Button
        >
      </template>
      <!-- 删除 -->
      <template slot-scope="{ row, index }" slot="delete">
        <Button
          type="success"
          size="small"
          v-hasPermission="[
            'permissionsConfigurationManagement:accountGroupConfig:log'
          ]"
          @click="logClick(row)"
          >{{ $t("alarms.common.operationLog") }}</Button
        >
        <span @click="doDelete(index)">
          <Button
            type="error"
            size="small"
            @click="accountGroupsDelmodal = true"
            v-hasPermission="[
              'permissionsConfigurationManagement:accountGroup:delete'
            ]"
            >{{ $t("common.del") }}</Button
          >
        </span>
      </template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <!-- 删除组模式框 -->
    <Modal v-model="accountGroupsDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ accountGroupName }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAccountGroup()"
          :disabled="isDisable"
        >
          {{ $t("common.del") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑财务账户组 -->
    <Modal
      v-model="accountGroupEditmodal"
      :title="$t('RIAccountGroupManagement.editRIAccountGroup')"
      :loading="loading"
      @on-ok="accountGroupSubmit('accountGroupEditForm')"
      @on-cancel="accountGroupReset('accountGroupEditForm')"
      :mask-closable="false"
      :okText="$t('alarms.common.ok')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="accountGroupEditForm"
        :model="accountGroupEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <FormItem
          :label="$t('permission_configuration_management.account.company')"
          prop="companyId"
        >
          <div>{{ this.companyName }}</div>
        </FormItem>
        <!-- 地区 -->
        <FormItem
          :label="$t('permission_configuration_management.account.area')"
          prop="areaType"
        >
          <Select
            v-model="accountGroupEditForm.areaType"
            style="width:300px;"
            @on-change="changeAccount(accountGroupEditForm.areaType)"
            :transfer="true"
            disabled
          >
            <Option
              :value="item.id"
              v-for="(item, index) in areaTypeList"
              v-bind:key="index"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 区域 -->
        <FormItem
          :label="$t('permission_configuration_management.account.region')"
          prop="region"
        >
          <Select
            v-model="accountGroupEditForm.region"
            style="width:300px;"
            :transfer="true"
          >
            <Option
              :value="item.name"
              v-for="item in regionList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 财务账户组名称 -->
        <FormItem
          :label="$t('RIAccountGroupManagement.RIAccountGroupName')"
          prop="accountGroupName"
        >
          <Input
            v-model="accountGroupEditForm.accountGroupName"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>

        <!-- 备注 -->
        <FormItem :label="$t('RIAccountGroupManagement.comment')" prop="remark">
          <Input
            v-model="accountGroupEditForm.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="Enter something..."
            style="width:300px;"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

let tableAccountGroupVue = {};
export default {
  name: "TableAccountGroup",
  components: {
    ConfigurationManagementOperationLog
  },
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      self.$api.accountGroup
        .checkAccountGroupName({
          companyId: this.companyId,
          accountGroupName: this.accountGroupEditForm.accountGroupName
        })
        .then(res => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch(err => {
          if (err.status == 400) {
            callback(new Error("财务账户组名称不能重复!"));
          }
        });
    };
    return {
      isShowOperationLog: false,
      companyId: "",
      companyName: "",
      val: "",
      companyIds: "",
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountGroupsDelmodal: false,
      accountGroupEditmodal: false,
      accountGroupName: "",
      modal_loading: false,
      isDisable: false,
      accountGroupEditForm: {
        accountGroupName: "",
        remark: "",
        areaType: "",
        region: ""
      },
      areaTypeList: [
        {
          id: 1,
          name: this.$t("RIAccountGroupManagement.China")
        },
        {
          id: 2,
          name: this.$t("RIAccountGroupManagement.Overseas")
        }
      ],
      regionList: [],
      loading: true,
      columns: [
        {
          title: this.$t("RIAccountGroupManagement.companyName"),
          key: "companyName"
        },
        {
          title: this.$t("RIAccountGroupManagement.RIAccountGroupName"),
          key: "accountGroupName",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    //编辑组弹出层
                    this.accountGroupEditmodal = true;
                    this.accountGroupEditForm.id = params.row.id;
                    // 组名称
                    this.accountGroupEditForm.accountGroupName =
                      params.row.accountGroupName;
                    // 备注
                    this.accountGroupEditForm.remark = params.row.remark;
                    // 地区
                    if (
                      params.row.areaType ===
                      this.$t("RIAccountGroupManagement.China")
                    ) {
                      this.accountGroupEditForm.areaType = 1;
                    } else if (
                      params.row.areaType ===
                      this.$t("RIAccountGroupManagement.Overseas")
                    ) {
                      this.accountGroupEditForm.areaType = 2;
                    }
                    // 区域
                    this.$api.accountGroup
                      .getRegionByAreaType(
                        "areaType",
                        this.accountGroupEditForm.areaType
                      )
                      .then(res => {
                        this.regionList = res.data;
                      });
                    this.accountGroupEditForm.region = params.row.region;
                    // 公司ID
                    this.companyId = params.row.companyId;
                    this.companyName = params.row.companyName;
                  }
                }
              },
              params.row.accountGroupName
            );
          }
        },
        {
          title: this.$t("common.configure"),
          slot: "configure"
        },
        {
          title: this.$t("RIAccountGroupManagement.region"),
          key: "areaType"
        },
        {
          title: this.$t("RIAccountGroupManagement.AvailabilityZone"),
          key: "region"
        },
        {
          title: this.$t("common.note"),
          key: "remark"
        },
        {
          title: this.$t("common.operation"),
          slot: "delete"
        }
      ],
      accountGroupData: [],
      ruleValidate: {
        accountGroupName: [
          {
            required: true,
            message: this.$t(
              "RIAccountGroupManagement.accountGroupNameNotEmpty"
            ),
            trigger: "blur"
          },
          {
            type: "string",
            message: this.$t(
              "RIAccountGroupManagement.accountGroupNameValidateMsg"
            ),
            pattern: "^.{4,20}$",
            trigger: "blur"
          },
          { validator: validNameRepeatedCheck, trigger: "blur" }
        ],
        areaType: [
          {
            required: true,
            message: this.$t("RIAccountGroupManagement.pleaseSelectArea"),
            trigger: "change",
            type: "number"
          }
        ],
        region: [
          {
            required: true,
            message: this.$t("RIAccountGroupManagement.pleaseSelectRegion"),
            trigger: "change"
          }
        ]
      }
    };
  },
  beforeCreate: function() {
    tableAccountGroupVue = this;
  },
  mounted: function() {
    tableAccountGroupVue.getAccountGroupData();
  },
  methods: {
    // 切换地区
    changeAccount: function() {
      if (
        this.accountGroupEditForm.areaType == "" ||
        this.accountGroupEditForm.areaType == null
      ) {
        return;
      }
      this.accountGroupEditForm.region = "";
      this.$api.accountGroup
        .getRegionByAreaType("areaType", this.accountGroupEditForm.areaType)
        .then(res => {
          this.regionList = res.data;
        });
    },
    showAll: function() {
      tableAccountGroupVue.getAccountGroupData();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.accountGroupName = this.accountGroupData[index].accountGroupName;
    },
    // 点击账户组配置跳转
    accountGroupConfig: function(row) {
      this.$router.push({
        path: "/permissionsConfigurationManagement/accountGroupConfig",
        query: {
          id: row.id,
          accountGroupName: row.accountGroupName,
          areaType: row.areaType,
          region: row.region
        }
      });
    },
    // 分页显示数据
    getAccountGroupData: function() {
      // 获取AccountGroupSearch里面的搜索内容
      eventBus.$on("accountGroupSearchName", function(val) {
        tableAccountGroupVue.val = val;
      });
      // 获取AccountGroupSearch里面的搜索内容
      eventBus.$on("companyIds", function(companyIds) {
        tableAccountGroupVue.companyIds = companyIds;
      });
      //分页
      this.$api.accountGroup
        .pageAccountGroup({
          accountGroupName: tableAccountGroupVue.val,
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: tableAccountGroupVue.companyIds
        })
        .then(res => {
          this.accountGroupData = res.data.records;
          // 地区
          for (var i = 0; i < this.accountGroupData.length; i++) {
            if (this.accountGroupData[i].areaType === 1) {
              this.accountGroupData[i].areaType = this.$t(
                "RIAccountGroupManagement.China"
              );
            } else {
              this.accountGroupData[i].areaType = this.$t(
                "RIAccountGroupManagement.Overseas"
              );
            }
          }
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableAccountGroupVue.getAccountGroupData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableAccountGroupVue.getAccountGroupData();
    },
    // 删除
    removeAccountGroup: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.accountGroup
        .deleteAccountGroup("id", this.accountGroupData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableAccountGroupVue.getAccountGroupData();
            this.isDisable = false;
            this.modal_loading = false;
            this.accountGroupsDelmodal = false;
            this.$Message.success("删除成功");
          }, 1000);
        });
    },
    // 销毁accountGroupSearchName
    beforeDestroy: function() {
      eventBus.$off("accountGroupSearchName");
    },
    // 编辑账户
    /*************************************************************************/
    // 确定
    accountGroupSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          var editGroup = {
            id: this.accountGroupEditForm.id,
            accountGroupName: this.accountGroupEditForm.accountGroupName,
            remark: this.accountGroupEditForm.remark,
            areaType: this.accountGroupEditForm.areaType,
            region: this.accountGroupEditForm.region
          };

          this.$api.accountGroup.updateAccountGroup(editGroup).then(res => {
            this.data = res.data;
            setTimeout(() => {
              tableAccountGroupVue.getAccountGroupData();
              this.$refs[name].resetFields();
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.$Message.success("编辑成功");
              this.accountGroupEditmodal = false;
            }, 1000);
          });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error("编辑失败");
        }
      });
    },
    // 取消
    accountGroupReset: function(name) {
      this.$refs[name].resetFields();
    },
    // 操作日志
    /****************************************************/
    logClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          11
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account_group/TableAccountGroup.vue